/* ZM layer — behaviour for the zx-* sections. No dependencies; relies on the base theme only for
   <product-form>, the cart drawer and the publish/subscribe helpers when they exist. */
(function () {
  'use strict';
  var ZX = (window.ZX = window.ZX || {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var done = new WeakSet();

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el) { if (done.has(el)) return false; done.add(el); return true; }
  function isRtl(el) { return getComputedStyle(el).direction === 'rtl'; }

  /* ---------- money ---------- */
  ZX.amount = function (cents) {
    var v = (Math.round(cents) / 100).toFixed(2);
    if (v.slice(-3) === '.00') v = v.slice(0, -3);
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  ZX.money = function (cents) {
    if (ZX.currency === 'AED') {
      return '<span class="zx-money" dir="rtl"><span class="zx-money__n">' + ZX.amount(cents) + '</span> <svg class="zx-aed" role="img" aria-label="' + ((ZX.t && ZX.t.aed) || 'AED') + '" viewBox="0 0 344.84 299.91"><use href="#zx-aed"></use></svg></span>';
    }
    var f = ZX.moneyFormat || '{{amount}}';
    return '<span class="zx-money">' + f.replace(/\{\{\s*amount[^}]*\}\}/, (Math.round(cents) / 100).toFixed(2)) + '</span>';
  };

  /* ---------- menu drawer ---------- */
  function initDrawers(root) {
    $$('[data-zx-open]', root).forEach(function (btn) {
      if (!once(btn)) return;
      var panel = document.getElementById(btn.getAttribute('data-zx-open'));
      if (!panel) return;
      function close() {
        panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('zx-lock');
        if (typeof removeTrapFocus === 'function') removeTrapFocus(btn); else btn.focus();
      }
      function open() {
        panel.hidden = false; btn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('zx-lock');
        var dialog = $('[role="dialog"]', panel) || panel, first = $('[data-zx-close]:not(.zx-drawer__bg)', dialog) || $('button, a, input', dialog);
        if (typeof trapFocus === 'function') trapFocus(dialog, first); else if (first) first.focus();
      }
      btn.addEventListener('click', function () { panel.hidden ? open() : close(); });
      $$('[data-zx-close]', panel).forEach(function (x) { x.addEventListener('click', close); });
      panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- desktop menu: links that do not fit move into a "More" dropdown ---------- */
  function initNav(root) {
    $$('[data-zx-nav]', root).forEach(function (nav) {
      if (!once(nav)) return;
      var more = $('[data-zx-more]', nav), list = more ? $('.zx-nav__sub', more) : null;
      var items = $$('.zx-nav__item', nav).filter(function (it) { return it !== more; });
      function fit() {
        if (!more) { nav.classList.add('is-ready'); return; }
        items.forEach(function (it) { it.hidden = false; });
        list.textContent = ''; more.hidden = true;
        if (!nav.clientWidth) return;
        if (nav.scrollWidth > nav.clientWidth + 1) {
          more.hidden = false;
          for (var i = items.length - 1; i > 0 && nav.scrollWidth > nav.clientWidth + 1; i--) {
            var a = $('.zx-nav__a', items[i]), c = document.createElement('a');
            c.href = a.getAttribute('href'); c.textContent = a.textContent;
            if (a.hasAttribute('aria-current')) c.setAttribute('aria-current', 'page');
            list.insertBefore(c, list.firstChild); items[i].hidden = true;
          }
        }
        nav.classList.add('is-ready');
      }
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(function () { window.requestAnimationFrame(fit); }).observe(nav);
      else window.addEventListener('resize', fit);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    $$('[data-zx-countdown]', root).forEach(function (el) {
      if (!once(el)) return;
      var end = new Date(el.getAttribute('data-zx-countdown')).getTime();
      if (isNaN(end)) return;
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { el.hidden = true; return; }
        var d = Math.floor(left / 864e5), h = Math.floor((left % 864e5) / 36e5), m = Math.floor((left % 36e5) / 6e4);
        var left2 = d ? ('0' + d).slice(-2) + ' ' + el.getAttribute('data-label-d') : ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
        el.textContent = '· ' + (el.getAttribute('data-tpl') || '__T__').replace('__T__', left2);
        el.hidden = false;
      }
      tick(); setInterval(tick, 30000);
    });
  }

  /* ---------- helpers for horizontal scrollers ---------- */
  function centerDelta(track, item) {
    var t = track.getBoundingClientRect(), r = item.getBoundingClientRect();
    return r.left + r.width / 2 - (t.left + t.width / 2);
  }
  function nearest(track, items) {
    var best = 0, bd = Infinity;
    items.forEach(function (it, i) { var d = Math.abs(centerDelta(track, it)); if (d < bd) { bd = d; best = i; } });
    return best;
  }
  function mouseDrag(track, onStart) {
    var st = null;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || (e.target.closest && e.target.closest('button, input, select'))) return;
      st = { x: e.clientX, s: track.scrollLeft, moved: false };
      if (onStart) onStart();
    });
    window.addEventListener('pointermove', function (e) {
      if (!st) return;
      var dx = e.clientX - st.x;
      if (Math.abs(dx) > 4 && !st.moved) { st.moved = true; track.classList.add('is-dragging'); }
      if (st.moved) track.scrollLeft = st.s - dx;
    });
    function end() {
      if (!st) return;
      var moved = st.moved; st = null;
      setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
      if (!moved) return;
      var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      track.addEventListener('click', stop, true);
      setTimeout(function () { track.removeEventListener('click', stop, true); }, 80);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
  }
  /* runs once, when the element is within about two screens of the viewport */
  function nearScreen(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); cb(); } }, { rootMargin: '200% 0px' });
    io.observe(el);
  }
  function watchVisible(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (en) { cb(en[0].isIntersecting); }, { threshold: 0.25 }).observe(el);
  }

  /* ---------- plain scroller: arrows + mouse drag ---------- */
  function initScrollers(root) {
    $$('[data-zx-scroller]', root).forEach(function (box) {
      if (!once(box)) return;
      var track = $('[data-zx-track]', box); if (!track) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8 * (isRtl(track) ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' }); }
      var p = $('[data-zx-prev]', box), n = $('[data-zx-next]', box);
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
      var dotsBox = $('[data-zx-dots]', box), dots = [];
      function paintDots() {
        if (!dots.length) return;
        var max = track.scrollWidth - track.clientWidth, pos = max > 0 ? Math.abs(track.scrollLeft) / max : 0;
        var on = Math.round(pos * (dots.length - 1));
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === on); });
      }
      function sync() {
        box.classList.toggle('no-scroll', track.scrollWidth <= track.clientWidth + 4);
        if (!dotsBox) return;
        var pages = track.clientWidth ? Math.min(8, Math.ceil(track.scrollWidth / track.clientWidth)) : 0;
        if (pages < 2) pages = 0;
        if (pages !== dots.length) {
          dotsBox.textContent = ''; dots = [];
          for (var i = 0; i < pages; i++) { var d = document.createElement('i'); dotsBox.appendChild(d); dots.push(d); }
        }
        paintDots();
      }
      sync(); window.addEventListener('resize', sync);
      if (dotsBox) track.addEventListener('scroll', function () { window.requestAnimationFrame(paintDots); }, { passive: true });
      mouseDrag(track);
    });
  }

  /* ---------- hero slider ---------- */
  function initSliders(root) {
    $$('[data-zx-slider]', root).forEach(function (box) {
      if (!once(box)) return;
      var track = $('[data-zx-track]', box), slides = $$('[data-zx-slide]', box), dotsBox = $('[data-zx-dots]', box);
      if (!track || slides.length < 2) return;
      var dots = [], timer = null, visible = false, cur = 0;
      function go(i) {
        cur = (i + slides.length) % slides.length;
        track.scrollBy({ left: centerDelta(track, slides[cur]), behavior: reduce ? 'auto' : 'smooth' });
      }
      if (dotsBox) slides.forEach(function (s, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'zx-dot'; b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', function () { stop(); go(i); }); dotsBox.appendChild(b); dots.push(b);
      });
      var frame = track.parentNode;
      frame.classList.toggle('has-many', slides.length > 5);
      function paint() {
        cur = nearest(track, slides);
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === cur); if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        frame.classList.toggle('is-end', slides[cur].classList.contains('zx-slide--end'));
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      paint();
      var p = $('[data-zx-prev]', box), n = $('[data-zx-next]', box);
      if (p) p.addEventListener('click', function () { stop(); go(cur - 1); });
      if (n) n.addEventListener('click', function () { stop(); go(cur + 1); });
      function stop() { clearInterval(timer); timer = null; box.setAttribute('data-stopped', ''); }
      function start() {
        if (timer || reduce || box.getAttribute('data-autoplay') !== 'true' || box.hasAttribute('data-stopped')) return;
        timer = setInterval(function () { if (visible) go(cur + 1); }, (parseInt(box.getAttribute('data-speed'), 10) || 5) * 1000);
      }
      ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
      watchVisible(box, function (v) { visible = v; if (v) start(); });
    });
  }

  /* ---------- floating product: use the image as is when it is already transparent, otherwise remove a plain
     (white / grey / single colour) background by growing a region inwards from the border. The strictest setting
     is tried first so a white tube, cap or pump on a white background is never eaten; a looser one is used only
     while pieces of background still reach the frame. Busy photos and scenes are left alone on their white plate.
     The pixel work runs in a background worker so the page never stutters; browsers without that support do the
     same work on the page itself. ---------- */
  function idle(fn) { if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 600 }); else window.setTimeout(fn, 40); }

  /* Pure pixel work shared by the worker and the fallback. It is copied into the worker as text, so it must not use
     anything defined outside itself. Returns 0 (leave the picture alone), 1 (already transparent) or the
     [left, top, width, height] of the product after clearing the background in `d`. */
  function cutPixels(d, w, h) {
    var LV = [[14, 5], [26, 8], [40, 11], [54, 14]], n = w * h, i, k;
    var cs = [0, w - 1, (h - 1) * w, n - 1, w >> 1, (h - 1) * w + (w >> 1), (h >> 1) * w, (h >> 1) * w + w - 1], clear = 0;
    for (k = 0; k < cs.length; k++) if (d[cs[k] * 4 + 3] < 40) clear++;
    if (clear >= 4) return 1;
    var rs = [], gs = [], bs = [], step = Math.max(1, Math.floor(w / 40));
    var take = function (q) { rs.push(d[q * 4]); gs.push(d[q * 4 + 1]); bs.push(d[q * 4 + 2]); };
    for (k = 0; k < w; k += step) { take(k); take((h - 1) * w + k); }
    for (k = 0; k < h; k += step) { take(k * w); take(k * w + w - 1); }
    var med = function (arr) { arr = arr.slice().sort(function (p, q) { return p - q; }); return arr[arr.length >> 1]; };
    var R = med(rs), G = med(gs), B = med(bs), off = 0;
    for (k = 0; k < rs.length; k++) if (Math.abs(rs[k] - R) + Math.abs(gs[k] - G) + Math.abs(bs[k] - B) > 60) off++;
    if (off / rs.length > 0.22 || R + G + B < 540) return 0;
    var mark = new Uint8Array(n), stack = new Int32Array(n), sp, GT, LT, gone, lv, edge;
    var ok = function (q, from) {
      var o = q * 4;
      if (Math.abs(d[o] - R) + Math.abs(d[o + 1] - G) + Math.abs(d[o + 2] - B) > GT) return false;
      if (from < 0) return true;
      var f = from * 4;
      return Math.abs(d[o] - d[f]) + Math.abs(d[o + 1] - d[f + 1]) + Math.abs(d[o + 2] - d[f + 2]) <= LT;
    };
    var push = function (q, from) { if (!mark[q] && ok(q, from)) { mark[q] = 1; stack[sp++] = q; } };
    for (lv = 0; lv < LV.length; lv++) {
      GT = LV[lv][0]; LT = LV[lv][1]; sp = 0;
      if (lv) mark.fill(0);
      for (k = 0; k < w; k++) { push(k, -1); push((h - 1) * w + k, -1); }
      for (k = 0; k < h; k++) { push(k * w, -1); push(k * w + w - 1, -1); }
      while (sp) {
        i = stack[--sp];
        var px = i % w, py = (i - px) / w;
        if (px > 0) push(i - 1, i);
        if (px < w - 1) push(i + 1, i);
        if (py > 0) push(i - w, i);
        if (py < h - 1) push(i + w, i);
      }
      /* what is kept must stand clear of the frame, otherwise background is still attached to it */
      edge = 0;
      for (k = 0; k < w; k++) { if (!mark[k]) edge++; if (!mark[(h - 1) * w + k]) edge++; }
      for (k = 0; k < h; k++) { if (!mark[k * w]) edge++; if (!mark[k * w + w - 1]) edge++; }
      if (edge / (2 * w + 2 * h) <= 0.03) break;
    }
    if (lv === LV.length) return 0;
    gone = 0;
    for (i = 0; i < n; i++) gone += mark[i];
    if (gone / n < 0.1 || gone / n > 0.97) return 0;
    /* a real product is one solid shape; a shape full of gaps means the cut went wrong */
    var x0 = new Int32Array(h).fill(w), x1 = new Int32Array(h).fill(-1), y0 = new Int32Array(w).fill(h), y1 = new Int32Array(w).fill(-1), rc = new Int32Array(h), cc = new Int32Array(w), qx, qy, hull = 0;
    for (qy = 0; qy < h; qy++) for (qx = 0; qx < w; qx++) if (!mark[qy * w + qx]) {
      if (qx < x0[qy]) x0[qy] = qx;
      if (qx > x1[qy]) x1[qy] = qx;
      if (qy < y0[qx]) y0[qx] = qy;
      if (qy > y1[qx]) y1[qx] = qy;
      rc[qy]++; cc[qx]++;
    }
    for (qy = 0; qy < h; qy++) for (qx = x0[qy]; qx <= x1[qy]; qx++) if (qy >= y0[qx] && qy <= y1[qx]) hull++;
    if (!hull || (n - gone) / hull < 0.8) return 0;
    for (i = 0; i < n; i++) {
      if (mark[i]) { d[i * 4 + 3] = 0; continue; }
      qx = i % w; qy = (i - qx) / w;
      if ((qx > 0 && mark[i - 1]) || (qx < w - 1 && mark[i + 1]) || (qy > 0 && mark[i - w]) || (qy < h - 1 && mark[i + w])) d[i * 4 + 3] = 150;
    }
    /* trim the empty margin so the product itself fills the tile (stray dots near the frame are ignored) */
    var need = Math.max(2, Math.round(w * 0.006)), bx0 = 0, bx1 = w - 1, by0 = 0, by1 = h - 1, pad = 3;
    while (bx0 < bx1 && cc[bx0] < need) bx0++;
    while (bx1 > bx0 && cc[bx1] < need) bx1--;
    while (by0 < by1 && rc[by0] < need) by0++;
    while (by1 > by0 && rc[by1] < need) by1--;
    bx0 = Math.max(0, bx0 - pad); by0 = Math.max(0, by0 - pad); bx1 = Math.min(w - 1, bx1 + pad); by1 = Math.min(h - 1, by1 + pad);
    return [bx0, by0, bx1 - bx0 + 1, by1 - by0 + 1];
  }

  /* The worker's whole program; `process` is cutPixels, handed in as text. Nothing from the page is visible here.
     Finished pictures are kept in the browser's cache storage (by picture address), so the next page or the next visit
     gets them at once without downloading or working again. */
  function cutWorkerMain(process) {
    var NAME = 'zx-cut-v4', store = null;
    var open = function () {
      if (!store) {
        store = (self.caches ? self.caches.open(NAME) : Promise.resolve(null)).catch(function () { return null; });
        if (self.caches) self.caches.keys().then(function (names) { names.forEach(function (nm) { if (nm.indexOf('zx-cut-') === 0 && nm !== NAME) self.caches.delete(nm); }); }).catch(function () {});
      }
      return store;
    };
    var keep = function (cache, url, kind, blob) {
      if (!cache) return;
      try {
        cache.put(url, new Response(blob || kind, { headers: { 'Content-Type': blob ? 'image/png' : 'text/plain', 'X-Zx': kind } })).then(function () {
          return cache.keys().then(function (keys) { if (keys.length > 180) for (var i = 0; i < 50; i++) cache.delete(keys[i]); });
        }).catch(function () {});
      } catch (err) { /* storage full or blocked: carry on without it */ }
    };
    self.onmessage = function (e) {
      var id = e.data.id, url = e.data.url;
      var fail = function () { self.postMessage({ id: id, err: true }); };
      var work = function (cache) {
        return fetch(url, { mode: 'cors', credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('http'); return r.blob(); })
          .then(function (b) { return self.createImageBitmap(b); })
          .then(function (bmp) {
            var w = bmp.width, h = bmp.height, c = new self.OffscreenCanvas(w, h), x = c.getContext('2d');
            x.drawImage(bmp, 0, 0);
            var im = x.getImageData(0, 0, w, h), res = process(im.data, w, h);
            if (res === 1) { keep(cache, url, 'keep'); self.postMessage({ id: id, ok: true, keep: true }); return null; }
            if (!res) { keep(cache, url, 'plate'); self.postMessage({ id: id, ok: false }); return null; }
            x.putImageData(im, 0, 0);
            var out = c;
            if (res[2] < w || res[3] < h) { out = new self.OffscreenCanvas(res[2], res[3]); out.getContext('2d').drawImage(c, res[0], res[1], res[2], res[3], 0, 0, res[2], res[3]); }
            return out.convertToBlob({ type: 'image/png' }).then(function (blob) { keep(cache, url, 'cut', blob); self.postMessage({ id: id, ok: true, blob: blob }); });
          });
      };
      try {
        open().then(function (cache) {
          if (!cache) return work(null);
          return cache.match(url).then(function (hit) {
            if (!hit) return work(cache);
            var kind = hit.headers.get('X-Zx');
            if (kind === 'keep') { self.postMessage({ id: id, ok: true, keep: true }); return null; }
            if (kind === 'plate') { self.postMessage({ id: id, ok: false }); return null; }
            return hit.blob().then(function (blob) { self.postMessage({ id: id, ok: true, blob: blob, cached: true }); });
          });
        }).catch(fail);
      } catch (err) { fail(); }
    };
  }

  var cutW = null, cutJobs = {}, cutSeq = 0;
  var cutWOk = typeof window.Worker === 'function' && typeof window.OffscreenCanvas === 'function' && typeof window.createImageBitmap === 'function' && !!(window.OffscreenCanvas.prototype && window.OffscreenCanvas.prototype.convertToBlob);
  function cutInWorker(url, cb) {
    try {
      if (!cutW) {
        var src = '(' + cutWorkerMain.toString() + ')(' + cutPixels.toString() + ')';
        cutW = new window.Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
        cutW.onmessage = function (e) { var job = cutJobs[e.data.id]; if (!job) return; delete cutJobs[e.data.id]; job(e.data); };
        cutW.onerror = function () { cutWOk = false; var all = cutJobs; cutJobs = {}; Object.keys(all).forEach(function (key) { all[key]({ err: true }); }); };
      }
      var id = ++cutSeq, answered = false;
      cutJobs[id] = function (data) { if (answered) return; answered = true; cb(data); };
      cutW.postMessage({ id: id, url: url });
      window.setTimeout(function () { var job = cutJobs[id]; if (job) { delete cutJobs[id]; job({ err: true }); } }, 9000);
    } catch (e) { cutWOk = false; cb({ err: true }); }
  }
  /* the same work on the page itself, for browsers that cannot do it in a worker */
  function cutOnPage(img, url, done) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onerror = function () { done(false); };
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight, c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d'); x.drawImage(probe, 0, 0);
        var im = x.getImageData(0, 0, w, h), res = cutPixels(im.data, w, h), out = c;
        if (res === 1) { done(true); return; }
        if (!res) { done(false); return; }
        x.putImageData(im, 0, 0);
        if (res[2] < w || res[3] < h) { out = document.createElement('canvas'); out.width = res[2]; out.height = res[3]; out.getContext('2d').drawImage(c, res[0], res[1], res[2], res[3], 0, 0, res[2], res[3]); }
        out.toBlob(function (blob) { if (!blob) { done(false); return; } img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = URL.createObjectURL(blob); done(true); }, 'image/png');
      } catch (e) { done(false); }
    };
    probe.src = url;
  }
  function cutOut(img, done) {
    var src = img && (img.getAttribute('src') || img.currentSrc), url;
    if (!src) { done(false); return; }
    try { url = new URL(src, window.location.href); url.searchParams.set('width', '460'); } catch (e) { done(false); return; }
    url = url.toString();
    if (!cutWOk) { cutOnPage(img, url, done); return; }
    cutInWorker(url, function (r) {
      if (r.err) { cutOnPage(img, url, done); return; }
      if (!r.ok) { done(false); return; }
      if (r.keep) { done(true); return; }
      img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = URL.createObjectURL(r.blob); done(true);
    });
  }

  /* ---------- product pictures in cards: a picture with a lot of empty margin around the product is enlarged inside
     its frame so the product itself is clear. Only the margin is cropped by the frame; a photo that fills its frame, or
     has a busy background, is left as it is. Reads a 56px copy of the picture, so it costs almost nothing. ---------- */
  var FIT_SEL = '.zx-card__img img:not(.zx-card__img2), .zx-bitem__img img, .zx-step__img img';
  function fitOne(img) {
    if (img.zxFit || !img.naturalWidth || !img.naturalHeight) return;
    img.zxFit = 1;
    try {
      var S = 56, r = img.naturalWidth / img.naturalHeight, w = r >= 1 ? S : Math.max(8, Math.round(S * r)), h = r >= 1 ? Math.max(8, Math.round(S / r)) : S;
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, n = w * h, i, k, q, border = [], clear = 0;
      for (k = 0; k < w; k++) { border.push(k, (h - 1) * w + k); }
      for (k = 1; k < h - 1; k++) { border.push(k * w, k * w + w - 1); }
      for (k = 0; k < border.length; k++) if (d[border[k] * 4 + 3] < 60) clear++;
      var seeThrough = clear > border.length * 0.6, R = 0, G = 0, B = 0;
      if (!seeThrough) {
        var rs = [], gs = [], bs = [];
        for (k = 0; k < border.length; k++) { q = border[k] * 4; rs.push(d[q]); gs.push(d[q + 1]); bs.push(d[q + 2]); }
        var med = function (arr) { arr = arr.slice().sort(function (p, t) { return p - t; }); return arr[arr.length >> 1]; };
        R = med(rs); G = med(gs); B = med(bs);
        var same = 0;
        for (k = 0; k < rs.length; k++) if (Math.abs(rs[k] - R) + Math.abs(gs[k] - G) + Math.abs(bs[k] - B) <= 30) same++;
        if (same / rs.length < 0.82) return; /* the picture already reaches its edges, or has a busy background */
      }
      var rc = new Int32Array(h), cc = new Int32Array(w), px, py;
      for (i = 0; i < n; i++) {
        q = i * 4;
        var on = seeThrough ? d[q + 3] > 60 : (d[q + 3] > 60 && Math.abs(d[q] - R) + Math.abs(d[q + 1] - G) + Math.abs(d[q + 2] - B) > 26);
        if (on) { px = i % w; py = (i - px) / w; rc[py]++; cc[px]++; }
      }
      var bx0 = 0, bx1 = w - 1, by0 = 0, by1 = h - 1;
      while (bx0 < bx1 && cc[bx0] < 1) bx0++;
      while (bx1 > bx0 && cc[bx1] < 1) bx1--;
      while (by0 < by1 && rc[by0] < 1) by0++;
      while (by1 > by0 && rc[by1] < 1) by1--;
      if (bx1 <= bx0 || by1 <= by0) return;
      /* everything below is in fractions of the square frame, so the result holds at every screen size */
      var wf = Math.min(1, r), hf = Math.min(1, 1 / r), fx0 = bx0 / w, fx1 = (bx1 + 1) / w, fy0 = by0 / h, fy1 = (by1 + 1) / h;
      var sc = Math.min(0.94 / ((fx1 - fx0) * wf), 0.94 / ((fy1 - fy0) * hf), 2.4);
      if (sc < 1.06) return;
      var net = navigator.connection || {}, box = img.getBoundingClientRect().width; /* read the layout before any style is written */
      img.style.setProperty('--zx-fs', sc.toFixed(3));
      img.style.setProperty('--zx-fx', (-((fx0 + fx1) / 2 - 0.5) * wf * sc * 100).toFixed(2) + '%');
      img.style.setProperty('--zx-fy', (-((fy0 + fy1) / 2 - 0.5) * hf * sc * 100).toFixed(2) + '%');
      img.classList.add('is-fit');
      /* an enlarged picture needs more pixels to stay sharp: ask for a larger file, unless the visitor is saving data */
      if (sc >= 1.25 && box > 0 && img.getAttribute('srcset') && !net.saveData && !/2g/.test(net.effectiveType || '')) img.sizes = Math.min(900, Math.ceil(box * sc)) + 'px';
    } catch (e) { /* a picture from another address cannot be read: it simply stays as it is */ }
  }
  function initFit(root) {
    $$(FIT_SEL, root).forEach(function (img) { if (img.complete) fitOne(img); });
  }
  /* pictures that arrive later (lazy loading, load more, live search, brand panel) are fitted as they load */
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && !t.zxFit && t.matches && t.matches(FIT_SEL)) fitOne(t); }, true);

  /* ---------- page text: a short line that is all bold, or a short line right after a blank line, is a heading the
     owner typed without a heading style; a first line that only repeats the page title is dropped ---------- */
  function initRte(root) {
    $$('.zx-page .zx-rte', root).forEach(function (box) {
      if (!once(box)) return;
      var h1 = $('.zx-page__h', box.closest('.zx-page')), title = h1 ? h1.textContent.trim() : '';
      var letters = function (s) { return (s || '').replace(/[\s :.,!?؟،\-–—•✔]/g, ''); };
      $$('p', box).forEach(function (p, i) {
        var text = p.textContent.replace(/ /g, ' ').trim(), core = letters(text);
        if (!core || p.querySelector('br, img, a')) return;
        if (i === 0 && title && text.length <= 48 && text.indexOf(title) === 0) { p.classList.add('is-dup'); return; }
        var bold = p.querySelector('strong, b'), prev = p.previousElementSibling;
        var allBold = bold && text.length <= 60 && letters(bold.textContent).length >= core.length * 0.8;
        var afterGap = prev && prev.classList.contains('zx-gap') && text.length <= 32 && !/[.،,]$/.test(text);
        if (allBold || afterGap) p.classList.add('zx-rte__h');
      });
    });
  }

  /* ---------- pop carousels (featured tiles + makeup coverflow) ---------- */
  function initPops(root) {
    $$('[data-zx-pop]', root).forEach(function (box) {
      if (!once(box)) return;
      var track = $('[data-zx-track]', box), items = $$('[data-zx-item]', box);
      if (!track || !items.length) return;
      /* The pictures are prepared well before the carousel reaches the screen. With the background worker they are
         all done together; without it, one at a time in idle moments so the page stays smooth. A picture that is not
         ready 1.2 seconds after the carousel shows appears as it is and is swapped when its cut-out arrives. */
      var mode = box.getAttribute('data-cutout'), cutStarted = false, shown = false;
      function ready(it, yes) { it.classList.toggle('is-cutout', !!yes); it.classList.add('is-ready'); }
      function startCut() {
        if (cutStarted) return; cutStarted = true;
        if (mode === 'all' || mode === 'none') { items.forEach(function (it) { ready(it, mode === 'all'); }); return; }
        if (cutWOk) { items.forEach(function (it) { cutOut($('img', it), function (yes) { ready(it, yes); }); }); return; }
        var queue = items.slice();
        (function next() {
          var it = queue.shift(); if (!it) return;
          idle(function () { cutOut($('img', it), function (yes) { ready(it, yes); next(); }); });
        })();
      }
      function showAll() { if (shown) return; shown = true; window.setTimeout(function () { items.forEach(function (it) { it.classList.add('is-ready'); }); }, 1200); }
      box.classList.add('is-auto');
      nearScreen(box.closest('.shopify-section') || box, startCut);
      var timer = null, visible = false, raf = 0, dotsBox = $('[data-zx-dots]', box), dots = [];
      if (dotsBox) items.forEach(function () { var d = document.createElement('i'); dotsBox.appendChild(d); dots.push(d); });
      function stepPx() { return items.length > 1 ? Math.abs(items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left) || items[0].offsetWidth : items[0].offsetWidth; }
      function paint() {
        raf = 0;
        var sp = stepPx();
        items.forEach(function (it) {
          var d = centerDelta(track, it) / sp, a = Math.abs(d), near = Math.max(0, 1 - a);
          it.style.setProperty('--zx-near', near.toFixed(3));
          it.style.setProperty('--zx-d', Math.max(-1, Math.min(1, d)).toFixed(3));
          it.style.setProperty('--zx-a', Math.min(a, 3).toFixed(3));
          it.style.zIndex = String(20 - Math.round(a * 4));
          it.classList.toggle('is-on', near > 0.5);
          it.classList.toggle('is-center', a < 0.08);
        });
        if (dots.length) { var on = nearest(track, items); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === on); }); }
      }
      function req() { if (!raf) raf = window.requestAnimationFrame(paint); }
      function go(i, instant) {
        i = (i + items.length) % items.length;
        track.scrollBy({ left: centerDelta(track, items[i]), behavior: instant || reduce ? 'auto' : 'smooth' });
      }
      track.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      go(Math.min(2, items.length - 1), true); paint();
      function stop() { clearInterval(timer); timer = null; box.setAttribute('data-stopped', ''); }
      function start() {
        if (timer || reduce || box.getAttribute('data-autoplay') !== 'true' || box.hasAttribute('data-stopped')) return;
        timer = setInterval(function () { if (visible) go(nearest(track, items) + 1); }, (parseInt(box.getAttribute('data-speed'), 10) || 3) * 1000);
      }
      var p = $('[data-zx-prev]', box), n = $('[data-zx-next]', box);
      if (p) p.addEventListener('click', function () { stop(); go(nearest(track, items) - 1); });
      if (n) n.addEventListener('click', function () { stop(); go(nearest(track, items) + 1); });
      ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
      mouseDrag(track, stop);
      watchVisible(box, function (v) { visible = v; if (v) { req(); start(); startCut(); showAll(); } });
      if (!('IntersectionObserver' in window)) { startCut(); showAll(); }
    });
  }

  /* ---------- cart ---------- */
  /* After an add the base theme opens the drawer. The design confirms with the flying dot and the green
     tick instead, so that automatic open is skipped unless the owner enables it in Theme settings > ZM. */
  var quiet = 0, quietTimer = null;
  function quietDone() { quiet = Math.max(0, quiet - 1); }
  function quietAdd() {
    var drawer = document.querySelector('cart-drawer');
    if (ZX.openCart || !drawer || typeof drawer.open !== 'function') return;
    if (!drawer.zxOpen) {
      drawer.zxOpen = drawer.open;
      drawer.open = function (trigger) {
        if (!trigger && quiet > 0) { quietDone(); return; }
        return drawer.zxOpen(trigger);
      };
    }
    quiet++;
    clearTimeout(quietTimer); quietTimer = setTimeout(function () { quiet = 0; }, 10000);
  }
  ZX.bump = function () {
    var cart = document.getElementById('cart-icon-bubble'); if (!cart) return;
    cart.classList.remove('zx-bump'); void cart.offsetWidth; cart.classList.add('zx-bump');
  };

  ZX.addItems = function (items) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    quietAdd();
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || ZX.root || '/';
    return fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); return j; }); })
      .then(function (j) {
        if (cart && cart.renderContents && j.sections) { if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty'); cart.renderContents(j); ZX.bump(); }
        else if (!cart) window.location.href = rootUrl + 'cart';
        return j;
      }, function (e) { quietDone(); throw e; });
  };

  /* ---------- fly to cart ---------- */
  ZX.fly = function (from) {
    var cart = document.getElementById('cart-icon-bubble');
    if (reduce || !from || !cart) return;
    var a = from.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var dot = document.createElement('span'); dot.className = 'zx-fly'; dot.setAttribute('aria-hidden', 'true');
    dot.style.left = a.left + a.width / 2 + 'px'; dot.style.top = a.top + a.height / 2 + 'px';
    document.body.appendChild(dot);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        dot.style.left = b.left + b.width / 2 + 'px'; dot.style.top = b.top + b.height / 2 + 'px'; dot.classList.add('is-go');
      });
    });
    setTimeout(function () { dot.remove(); }, 560);
  };

  /* ---------- add buttons: fly + green "added" state ---------- */
  var pending = {}, liveEl = null;
  ZX.say = function (text) {
    if (!liveEl) { liveEl = document.createElement('div'); liveEl.className = 'visually-hidden'; liveEl.setAttribute('aria-live', 'polite'); liveEl.setAttribute('role', 'status'); document.body.appendChild(liveEl); }
    liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = text || ''; }, 60);
  };
  function markAdded(b) {
    b.classList.remove('is-error'); b.classList.add('is-added'); ZX.bump();
    if (ZX.t) ZX.say(ZX.t.added);
    if (!b.hasAttribute('data-zx-main-add')) return;
    var label = $('[data-zx-add-label]', b), box = b.closest('[data-zx-product]'), proxies = box ? $$('[data-zx-proxy-add]', box) : [];
    if (label && ZX.t) { label.textContent = ZX.t.added; proxies.forEach(function (p) { p.textContent = ZX.t.added; p.classList.add('is-added'); }); }
    setTimeout(function () {
      b.classList.remove('is-added');
      if (label) { label.textContent = label.getAttribute('data-add'); proxies.forEach(function (p) { p.textContent = label.getAttribute('data-add'); p.classList.remove('is-added'); }); }
    }, 1800);
  }
  function markFailed(b, message) {
    b.classList.remove('is-added'); b.classList.add('is-error');
    if (message) ZX.say(String(message));
    setTimeout(function () { b.classList.remove('is-error'); }, 1600);
  }
  function initAddFeedback() {
    document.addEventListener('submit', function (e) {
      var form = e.target, btn = form && form.querySelector ? form.querySelector('[data-zx-add]') : null;
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var idEl = form.querySelector('[name="id"]'), id = idEl ? String(idEl.value) : '';
      pending[id] = btn; quietAdd();
      var fromId = btn.getAttribute('data-fly-from');
      ZX.fly((fromId && document.getElementById(fromId)) || btn);
    }, true);
    function take(ev) {
      var id = ev && ev.productVariantId != null ? String(ev.productVariantId) : null, b = null;
      if (id && pending[id]) { b = pending[id]; delete pending[id]; return b; }
      var keys = Object.keys(pending); if (keys.length === 1) { b = pending[keys[0]]; delete pending[keys[0]]; }
      return b;
    }
    /* PUB_SUB_EVENTS is a top-level const in the base theme, so it is not on window: test with typeof. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source !== 'product-form') return; var b = take(ev); if (b) markAdded(b); });
      if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function (ev) { quietDone(); var b = take(ev); if (b) markFailed(b, ev && (ev.message || ev.errors)); });
    } else {
      document.addEventListener('submit', function () { setTimeout(function () { var b = take(null); if (b) markAdded(b); }, 900); }, true);
    }
  }

  /* ---------- routine / bundle ---------- */
  function initBundles(root) {
    $$('[data-zx-bundle]', root).forEach(function (box) {
      if (!once(box)) return;
      var pct = parseFloat(box.getAttribute('data-discount')) || 0;
      var elTotal = $('[data-zx-total]', box), elOrig = $('[data-zx-orig]', box), elOrigLine = $('[data-zx-orig-line]', box);
      var elCount = $('[data-zx-count]', box), elHints = $$('[data-zx-hint]', box), elDisc = $('[data-zx-disc]', box), elDiscRow = $('[data-zx-disc-row]', box);
      var btn = $('[data-zx-add-all]', box), err = $('[data-zx-err]', box);
      function calc() {
        var picks = $$('[data-zx-pick]', box);
        var usable = picks.filter(function (p) { return !p.disabled; });
        var on = usable.filter(function (p) { return p.checked; });
        var sum = on.reduce(function (s, p) { return s + (parseInt(p.getAttribute('data-price'), 10) || 0); }, 0);
        var all = usable.length > 1 && on.length === usable.length;
        var off = pct > 0 && all ? Math.round(sum * pct / 100) : 0;
        picks.forEach(function (p) { var w = p.closest('label'); if (w) w.classList.toggle('is-on', p.checked); });
        if (elTotal) elTotal.innerHTML = ZX.money(sum - off);
        if (elOrig) { elOrig.hidden = !off; elOrig.textContent = ZX.amount(sum); }
        if (elOrigLine) elOrigLine.innerHTML = ZX.money(sum);
        if (elCount) elCount.textContent = (elCount.getAttribute('data-tpl') || '').replace('__N__', on.length);
        if (elDiscRow) elDiscRow.hidden = !off;
        if (elDisc) elDisc.textContent = '−' + ZX.amount(off);
        elHints.forEach(function (elHint) {
          var tpl = off ? elHint.getAttribute('data-all') : elHint.getAttribute('data-part');
          elHint.textContent = (tpl || '').replace('__A__', ZX.amount(off)); elHint.hidden = !tpl;
        });
        if (btn) btn.disabled = !on.length;
        /* a "complete the set" block with nothing to add next to the product itself is not shown */
        var sec = box.closest('.zx-bundle-sec');
        if (sec && !sec.hasAttribute('data-zx-bundle-wait')) sec.hidden = picks.length < 2;
        return on;
      }
      box.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-zx-pick]')) calc(); });
      calc();
      /* the summary above is a plain sum; the cart is the truth. After adding, read the cart and show its real total,
         the saving and the name of the Shopify offer that produced it (for example "Buy 1 Get 1 Free"). */
      function showReal() {
        var real = $('[data-zx-real]', box); if (!real) return;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || ZX.root || '/';
        fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var names = [];
            var add = function (t) { if (t && names.indexOf(t) === -1) names.push(t); };
            (cart.cart_level_discount_applications || []).forEach(function (d) { add(d.title); });
            (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (al) { add(al.discount_application && al.discount_application.title); }); });
            var esc = function (t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; };
            var html = (real.getAttribute('data-now') || '').replace('__T__', ZX.money(cart.total_price));
            if (cart.total_discount > 0) {
              var tpl = names.length ? real.getAttribute('data-saved') : real.getAttribute('data-saved-plain');
              html += '<br>' + (tpl || '').replace('__S__', ZX.money(cart.total_discount)).replace('__O__', names.map(esc).join(' + '));
            }
            real.innerHTML = html; real.hidden = false; real.classList.remove('is-out');
            var note = $('[data-zx-offers-note]', box); if (note) note.hidden = true;
            /* a confirmation, not a fixture: it fades away after a few seconds */
            window.clearTimeout(real.zxT1); window.clearTimeout(real.zxT2);
            real.zxT1 = window.setTimeout(function () { real.classList.add('is-out'); real.zxT2 = window.setTimeout(function () { real.hidden = true; real.classList.remove('is-out'); if (note) note.hidden = false; }, 550); }, 8000);
          })
          .catch(function () {});
      }
      /* automatic suggestions: ask Shopify for this product's recommendations, rendered by the same section */
      var reco = $('[data-zx-reco]', box), wait = box.closest('[data-zx-bundle-wait]');
      if (reco && reco.getAttribute('data-url')) {
        fetch(reco.getAttribute('data-url'))
          .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function (html) {
            var got = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zx-reco]');
            if (!got || !got.querySelector('[data-zx-pick]')) return;
            reco.innerHTML = got.innerHTML;
            if (wait) wait.hidden = false;
            calc();
          })
          .catch(function () {});
      }
      if (btn) btn.addEventListener('click', function () {
        var on = calc(); if (!on.length || btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy'); if (err) err.textContent = '';
        ZX.fly(btn);
        ZX.addItems(on.map(function (p) { return { id: parseInt(p.getAttribute('data-id'), 10), quantity: 1 }; }))
          .then(function () {
            btn.classList.add('is-added'); btn.textContent = btn.getAttribute('data-done') || btn.textContent;
            setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = btn.getAttribute('data-label') || btn.textContent; }, 1800);
            showReal();
          })
          .catch(function (e) { if (err) err.textContent = e.message; })
          .then(function () { btn.classList.remove('is-busy'); });
      });
    });
  }

  /* ---------- product page ---------- */
  function initProducts(root) {
    $$('[data-zx-product]', root).forEach(function (box) {
      if (!once(box)) return;
      var variants = [], stock = {};
      try { variants = JSON.parse($('[data-zx-variants]', box).textContent) || []; } catch (e) {}
      try { stock = JSON.parse($('[data-zx-stockmap]', box).textContent) || {}; } catch (e) {}
      var form = $('form.zx-form', box), idInput = form ? form.querySelector('[name="id"]') : null;
      var qty = form ? form.querySelector('[name="quantity"]') : null, addBtn = $('[data-zx-main-add]', box);
      var current = variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0] || variants[0];
      var low = parseInt(box.getAttribute('data-low'), 10) || 0;

      function paint() {
        if (!current) return;
        var q = Math.max(1, parseInt(qty && qty.value, 10) || 1), sale = current.compare_at_price && current.compare_at_price > current.price;
        var now = $('[data-zx-now]', box), was = $('[data-zx-was]', box), off = $('[data-zx-off]', box);
        if (now) { now.innerHTML = ZX.money(current.price); now.classList.toggle('is-sale', !!sale); }
        if (was) { was.hidden = !sale; var wasN = $('[data-zx-was-n]', was); if (sale && wasN) wasN.innerHTML = ZX.money(current.compare_at_price); }
        if (off) { off.hidden = !sale; if (sale) off.textContent = '-' + Math.round((current.compare_at_price - current.price) * 100 / current.compare_at_price) + '%'; }
        var bn = $('[data-zx-bnpl]', box); if (bn) bn.innerHTML = ZX.money(Math.round(current.price / 4));
        var mem = $('[data-zx-member]', box); if (mem) mem.innerHTML = ZX.money(Math.round(current.price * (parseFloat(mem.getAttribute('data-keep')) || 100) / 100));
        $$('[data-zx-line]', box).forEach(function (el) { el.innerHTML = ZX.money(current.price * q); });
        var label = $('[data-zx-add-label]', box);
        if (label) label.textContent = current.available ? label.getAttribute('data-add') : label.getAttribute('data-sold');
        if (addBtn) addBtn.disabled = !current.available;
        if (idInput) { idInput.value = current.id; idInput.disabled = !current.available; }
        $$('[data-zx-proxy-add]', box).forEach(function (b) { b.disabled = !current.available; if (label) b.textContent = label.textContent; });
        $$('[data-zx-main-pick]').forEach(function (pick) {
          if (String(pick.getAttribute('data-product')) !== String(box.getAttribute('data-product'))) return;
          pick.setAttribute('data-id', current.id); pick.setAttribute('data-price', current.price);
          var was = pick.disabled; pick.disabled = !current.available;
          if (!current.available) pick.checked = false; else if (was) pick.checked = true;
          var item = pick.closest('label'), out = item ? item.querySelector('[data-zx-main-price]') : null;
          if (item) item.classList.toggle('is-off', !current.available);
          if (out) out.innerHTML = ZX.money(current.price);
          pick.dispatchEvent(new Event('change', { bubbles: true }));
        });
        var st = $('[data-zx-stock]', box), n = stock[current.id];
        if (st) {
          var show = low > 0 && typeof n === 'number' && n > 0 && n <= low; st.hidden = !show;
          if (show) $('[data-zx-stock-t]', st).textContent = (n === 1 && box.getAttribute('data-low-one')) || (n === 2 && box.getAttribute('data-low-two')) || (box.getAttribute('data-low-tpl') || '').replace('__N__', n);
        }
      }
      var groups = $$('.zx-opt', box);
      function syncPills() {
        groups.forEach(function (fs, k) {
          $$('input', fs).forEach(function (r) { r.checked = r.value === current.options[k]; });
          var out = fs.querySelector('[data-zx-opt-val]'); if (out) out.textContent = current.options[k];
        });
      }
      $$('[data-zx-opt]', box).forEach(function (input) {
        input.addEventListener('change', function () {
          var chosen = groups.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
          var changed = groups.indexOf(input.closest('.zx-opt'));
          var match = variants.filter(function (v) { return v.options.every(function (o, k) { return o === chosen[k]; }); })[0];
          if (!match) {
            /* that combination does not exist: keep the option just picked, prefer an available variant */
            var pool = variants.filter(function (v) { return v.options[changed] === chosen[changed]; });
            match = pool.filter(function (v) { return v.available; })[0] || pool[0];
          }
          if (!match) { syncPills(); return; }
          current = match; syncPills(); paint();
          if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
          if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', current.id); window.history.replaceState({}, '', u.toString()); }
          var mid = current.featured_media && current.featured_media.id;
          if (mid) { var slide = $('.zx-gal__m[data-media-id="' + mid + '"]', box), tr = $('.zx-gal [data-zx-track]', box); if (slide && tr) tr.scrollBy({ left: centerDelta(tr, slide), behavior: reduce ? 'auto' : 'smooth' }); }
        });
      });
      var q = $('[data-zx-qty]', box);
      if (q && qty) {
        $('[data-zx-dec]', q).addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); paint(); });
        $('[data-zx-inc]', q).addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; paint(); });
        qty.addEventListener('change', paint);
      }
      $$('[data-zx-proxy-add]', box).forEach(function (b) { b.addEventListener('click', function () { if (addBtn && !addBtn.disabled) addBtn.click(); }); });
      paint();

      /* gallery */
      var gal = $('[data-zx-gallery]', box);
      if (gal) {
        var tr = $('[data-zx-track]', gal), ms = $$('.zx-gal__m', gal), thumbs = $$('[data-zx-thumb]', gal), dotsBox = $('[data-zx-dots]', gal), dots = [];
        var frame = $('.zx-gal__frame', gal); if (frame && !frame.id) frame.id = 'zx-gal-' + box.getAttribute('data-section');
        if (dotsBox && ms.length > 1) ms.forEach(function () { var d = document.createElement('i'); dotsBox.appendChild(d); dots.push(d); });
        var sync = function () {
          var i = nearest(tr, ms);
          thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        };
        thumbs.forEach(function (t, k) { t.addEventListener('click', function () { tr.scrollBy({ left: centerDelta(tr, ms[k]), behavior: reduce ? 'auto' : 'smooth' }); }); });
        if (tr) { tr.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true }); sync(); }
      }

      /* sticky bar: shows once the main button leaves the screen */
      var bar = $('[data-zx-sticky]', box);
      if (bar && addBtn && 'IntersectionObserver' in window) {
        bar.hidden = false; document.body.classList.add('zx-has-sbar');
        new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
      }
    });
  }

  /* ---------- brands page ---------- */
  function initBrands(root) {
    $$('[data-zx-brands]', root).forEach(function (box) {
      if (!once(box)) return;
      var tiles = $$('[data-zx-brand]', box), panel = $('[data-zx-brand-panel]', box), out = $('[data-zx-brand-out]', box);
      var find = $('[data-zx-brand-find]', box), tpl = box.getAttribute('data-count-tpl') || '';
      var seq = 0;
      function pick(tile, byUser) {
        var mine = ++seq;
        tiles.forEach(function (t) { t.classList.toggle('is-on', t === tile); });
        var url = tile.getAttribute('href');
        $('[data-zx-brand-name]', panel).textContent = tile.getAttribute('data-name');
        var d = $('[data-zx-brand-desc]', panel); d.textContent = tile.getAttribute('data-desc') || ''; d.hidden = !d.textContent;
        var logo = $('[data-zx-brand-logo]', panel), img = $('.zx-brand__img', tile); logo.innerHTML = img ? img.innerHTML : '';
        var bg = $('[data-zx-brand-bg]', panel), ban = $('template[data-zx-banner]', tile); bg.innerHTML = ban ? ban.innerHTML : '';
        $('[data-zx-brand-all]', panel).setAttribute('href', url);
        $('[data-zx-brand-count]', panel).textContent = '';
        panel.hidden = false; out.classList.add('is-loading');
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=zx-brand-products')
          .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function (html) {
            if (mine !== seq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html'), bp = doc.querySelector('[data-zx-brand-products]');
            if (!bp) throw new Error();
            out.innerHTML = bp.innerHTML;
            var meta = out.querySelector('.zx-bp__meta');
            if (meta) $('[data-zx-brand-count]', panel).textContent = tpl.replace('__N__', meta.getAttribute('data-count'));
          })
          .catch(function () { if (mine !== seq) return; if (byUser) window.location.href = url; else out.textContent = ''; })
          .then(function () { if (mine === seq) out.classList.remove('is-loading'); });
      }
      tiles.forEach(function (t) { t.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); pick(t, true); }); });
      if (find) find.addEventListener('input', function () {
        var qv = find.value.trim().toLowerCase();
        tiles.forEach(function (t) { t.hidden = !!qv && t.getAttribute('data-name').toLowerCase().indexOf(qv) === -1; });
      });
      /* on the catalog page the brands sit above the full product list, so nothing is opened until a brand is tapped */
      if (tiles.length && panel && box.getAttribute('data-auto') !== 'false') pick(tiles[0], false);
    });
  }

  /* ---------- product rating link: scroll to the reviews widget on the page ---------- */
  function initReviewLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-zx-to-reviews]') : null; if (!a) return;
      var t = document.querySelector('#zx-reviews, #looxReviews, .loox-reviews-default, #judgeme_product_reviews, #shopify-product-reviews, .jdgm-review-widget');
      e.preventDefault();
      if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- language switch on Shopify's share-preview address: go straight to the same page in the other language
     (the usual form post can leave the preview there); everywhere else the form works as normal ---------- */
  function initLang(root) {
    if (!/\.shopifypreview\.com$/.test(window.location.hostname)) return;
    $$('[data-zx-lang-href]', root).forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('data-zx-lang-href');
        if (!href) return;
        e.preventDefault();
        window.location.href = href + window.location.search;
      });
    });
  }

  /* ---------- collection: 2 / 3 columns on phones (remembered) ---------- */
  function initCols(root) {
    var key = 'zx-cols-v2';
    try { if (window.localStorage.getItem(key) === '3') document.body.classList.add('zx-cols-3'); } catch (e) {}
    $$('[data-zx-cols]', root).forEach(function (btn) {
      if (!once(btn)) return;
      btn.addEventListener('click', function () {
        var three = document.body.classList.toggle('zx-cols-3');
        try { window.localStorage.setItem(key, three ? '3' : '2'); } catch (e) {}
      });
    });
  }

  /* ---------- ZM Club: monthly spend slider -> monthly saving ---------- */
  function initClub(root) {
    $$('[data-zx-club]', root).forEach(function (box) {
      if (!once(box)) return;
      var range = $('[data-zx-club-range]', box), spend = $('[data-zx-club-spend]', box), save = $('[data-zx-club-save]', box);
      var pct = parseFloat(box.getAttribute('data-discount')) || 0;
      if (!range) return;
      function paint() {
        var v = parseInt(range.value, 10) || 0, min = parseInt(range.min, 10) || 0, max = parseInt(range.max, 10) || 100;
        if (spend) spend.innerHTML = ZX.money(v * 100);
        if (save) save.innerHTML = ZX.money(Math.round(v * pct));
        range.style.setProperty('--zx-fill', ((v - min) * 100 / (max - min)) + '%');
      }
      range.addEventListener('input', paint);
      paint();
    });
  }

  /* ---------- header search: the longer hint only where there is room ---------- */
  function initSearchHint(root) {
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
    $$('[data-zx-ph]', root).forEach(function (el) { el.setAttribute('placeholder', el.getAttribute('data-zx-ph')); });
  }

  /* ---------- header search: results while typing (rendered by sections/zx-search-results.liquid) ---------- */
  function initSuggest(root) {
    $$('[data-zx-suggest-form]', root).forEach(function (form) {
      if (!once(form)) return;
      var input = form.querySelector('input[name="q"]'), panel = $('[data-zx-suggest]', form), seq = 0, timer = null;
      if (!input || !panel) return;
      function hide() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function show() { if (panel.innerHTML.trim()) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } }
      function run() {
        var q = input.value.trim(), mine = ++seq;
        if (q.length < 2) { panel.innerHTML = ''; hide(); return; }
        var base = form.getAttribute('action') || '/search';
        fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=zx-search-results')
          .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
          .then(function (html) {
            if (mine !== seq) return;
            var got = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-zx-suggest-results]');
            panel.innerHTML = got ? got.innerHTML : '';
            if (panel.innerHTML.trim()) show(); else hide();
          })
          .catch(function () { if (mine === seq) hide(); });
      }
      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
      input.addEventListener('focus', show);
      form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); input.blur(); } });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    });
  }

  /* ---------- product photos: click to enlarge, click again to zoom in / out ---------- */
  function initZoom() {
    var box = null;
    function close() { if (!box) return; box.remove(); box = null; document.documentElement.classList.remove('zx-lock'); }
    document.addEventListener('click', function (e) {
      var img = e.target.closest ? e.target.closest('.zx-gal__m img') : null;
      if (!img) return;
      var src = img.currentSrc || img.src, big = src;
      try { var u = new URL(src, window.location.href); u.searchParams.set('width', '1800'); big = u.toString(); } catch (err) {}
      box = document.createElement('div'); box.className = 'zx zx-zoom'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      var pic = document.createElement('img'); pic.src = big; pic.alt = img.alt || '';
      var x = document.createElement('button'); x.type = 'button'; x.className = 'zx-zoom__x'; x.setAttribute('aria-label', (ZX.t && ZX.t.close) || 'Close'); x.textContent = '×';
      box.appendChild(pic); box.appendChild(x); document.body.appendChild(box);
      document.documentElement.classList.add('zx-lock');
      pic.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var r = pic.getBoundingClientRect();
        pic.style.transformOrigin = ((ev.clientX - r.left) / r.width * 100) + '% ' + ((ev.clientY - r.top) / r.height * 100) + '%';
        box.classList.toggle('is-in');
      });
      box.addEventListener('click', close);
      x.focus();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- collection: "load more" appends the next page; without JS the link simply opens it ---------- */
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-zx-loadmore-btn]') : null; if (!btn) return;
      var box = btn.closest('[data-zx-loadmore]'), grid = document.getElementById('product-grid');
      if (!box || !grid || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      var url = btn.getAttribute('href');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(box.getAttribute('data-section')))
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), next = doc.getElementById('product-grid'), nb = doc.querySelector('[data-zx-loadmore]');
          if (!next || !next.children.length) throw new Error();
          Array.prototype.slice.call(next.children).forEach(function (li) {
            li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen'); li.removeAttribute('data-cascade');
            grid.appendChild(document.importNode(li, true));
          });
          if (nb) { var prev = nb.querySelector('[data-zx-loadmore-prev]'); if (prev) prev.remove(); box.innerHTML = nb.innerHTML; }
          else box.remove();
        })
        .catch(function () { window.location.href = url; });
    });
  }

  function init(root) {
    initDrawers(root); initNav(root); initCountdown(root); initSliders(root); initScrollers(root); initPops(root); initBundles(root); initProducts(root); initBrands(root); initRte(root); initFit(root); initLang(root); initCols(root); initSearchHint(root); initSuggest(root); initClub(root);
  }
  function boot() {
    init(document); initAddFeedback(); initReviewLinks(); initLoadMore(); initZoom();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.matches && e.target.matches('[data-zx-slide]') ? e.target : null, track = slide ? slide.parentNode : null;
      if (track) track.scrollBy({ left: centerDelta(track, slide), behavior: 'auto' });
    });
    if ('MutationObserver' in window) $$('product-recommendations').forEach(function (el) { new MutationObserver(function () { init(el); }).observe(el, { childList: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
